
































































import ChargeSessionApi from '@/services/ChargeSessionApi'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch, Prop, Emit } from 'vue-property-decorator'
import CdrDuration from './CdrDuration.vue'
import Time from '../../functions/Time'

@Component({
  components: {
    CdrDuration
  }
})
export default class SessionDetails extends Vue {
  @Prop({ default: null }) readonly sessionid?: number | number
  @Prop({ default: () => { return {} } }) readonly vCardProps?: any

  session: any = null
  loading = false

  @Watch('sessionid', { immediate: true })
  sessionidOnChanged (val: any, oldVal: any) {
    if (val !== 0) {
      this.fetchSession()
    }
  }

  get loc () {
    if (this.session.chargeLocation.Latitude && this.session.chargeLocation.Longitude) {
      return { lat: this.session.chargeLocation.Latitude, lng: this.session.chargeLocation.Longitude }
    }
    return null
  }

  calcDiff (start: string, end: string) {
    return Time.durationTime(start, end, 'd[Days] HH[h]mm[m]')
  }

  get price () {
    let price = 0
    if (this.session) {
      this.session.priceRecords.data.forEach((e: any) => {
        if (typeof e.PriceExclVAT === 'number' && e.RelationType === 5) {
          price += e.PriceExclVAT
        }
      })
    }
    // return price
    return (Math.round(price * 100) / 100).toFixed(2)
  }

  async fetchSession () {
    if (this.sessionid) {
      this.loading = true
      const data = await new ChargeSessionApi().details(this.sessionid)
      this.loading = false
      // console.log(data)
      this.session = data
    }
  }
}
